import { IGeolocation } from "@origin-digital/event-dispatcher";

export const DEFAULT_LOCATION: IGeolocation = {
  state: "NSW",
  postcode: "2000",
  source: "timezone",
};

export const timeZoneStateMap: { [key: string]: string } = {
  "Australia/ACT": "ACT",
  "Australia/Adelaide": "SA",
  "Australia/Brisbane": "QLD",
  "Australia/Broken_Hill": "NSW",
  "Australia/Canberra": "ACT",
  "Australia/Currie": "TAS",
  "Australia/Darwin": "NT",
  "Australia/Eucla": "WA",
  "Australia/Hobart": "TAS",
  "Australia/LHI": "NSW", //default to NSW
  "Australia/Lindeman": "QLD",
  "Australia/Lord_Howe": "NSW", //default to NSW
  "Australia/Melbourne": "VIC",
  "Australia/North": "NT",
  "Australia/NSW": "NSW",
  "Australia/Perth": "WA",
  "Australia/Queensland": "QLD",
  "Australia/South": "SA",
  "Australia/Sydney": "NSW",
  "Australia/Tasmania": "TAS",
  "Australia/Victoria": "VIC",
  "Australia/West": "WA",
  "Australia/Yancowinna": "NSW",
};

// Map of regions to their corresponding geolocation
export const regionMap: { [key: string]: IGeolocation } = {
  ACT: { state: "ACT", postcode: "2600" },
  VIC: { state: "VIC", postcode: "3000" },
  QLD: { state: "QLD", postcode: "4000" },
  SA: { state: "SA", postcode: "5000" },
  WA: { state: "WA", postcode: "6000" },
  TAS: { state: "TAS", postcode: "7000" },
  NT: { state: "NT", postcode: "0800" },
  NSW: DEFAULT_LOCATION,
};

export const getStateAndPostcode = (
  state: string | undefined
): IGeolocation => {
  if (!state) {
    return DEFAULT_LOCATION;
  }
  const upperState = state.toUpperCase();
  const stateAndPostcode = regionMap[upperState] || DEFAULT_LOCATION;
  return {
    ...stateAndPostcode,
    source: "timezone",
  };
};

export const getStateFromTimeZones = (timeZone: string | undefined): string =>
  timeZone && timeZone in timeZoneStateMap ? timeZoneStateMap[timeZone] : "NSW";
